import { Button, Card, Col, DatePicker, Flex, Form, Input, InputNumber, Layout, Popconfirm, Radio, RadioChangeEvent, Row, Select, Space } from "antd";
import { Content } from "antd/es/layout/layout";
import { enmActionType } from "../../models/enums/ActionType";
import { mdlActionCreateParamPair } from "../../models/domain/value-objects/ActionCreateParamPair";
import _, { first } from "lodash";
import { useTranslation } from "react-i18next";
import { HotelSelect } from "../common/HotelSelect";
import { mdlIdCodeNamePair } from "../../models/domain/IdCodeNamePair";
import { DateRangePicker } from "../common/DateRangePicker";
import dayjs, { Dayjs } from "dayjs";
import { enmPriceType } from "../../models/enums/PriceType";
import { enmCurrency } from "../../models/enums/Currency";
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useQuery } from "react-query";
import { ActionService } from "../../services/ActionService";
import { mdlActionPricePairHolder } from "../../models/domain/value-objects/ActionPricePairHolder";
import { mdlSpoRoomPriceItem } from "../../models/domain/SpoRoomPriceItem";
import { HotelRoomTypeNameSelect } from "../common/HotelRoomTypeNameSelect";
import { HotelBoardNameSelect } from "../common/HotelBoardNameSelect";
import { mdlServiceResponse } from "../../models/service-models/common/ServiceResponse";
import { mdlSpoOfferDetailResponse } from "../../models/service-models/action/SpoOfferDetailResponse";
import { useEffect, useState } from "react";
import { SFDatePicker } from "../common/DatePicker";

export type ActionWizardSecondProps = {
    selectedHotelSetter: Function;
    selectedHotel: string | undefined;
    createParamPairs: mdlActionCreateParamPair[];
    createParamPairSetter: Function;
    actionPriceHolder: mdlActionPricePairHolder;
    spoDetail?: mdlServiceResponse<mdlSpoOfferDetailResponse>;
}

export const ActionWizardSecond = (props: ActionWizardSecondProps) => {
    const [form] = Form.useForm();
    const { t } = useTranslation();
    const [req, setReq] = useState<mdlSpoRoomPriceItem>({});

    const {
        data,
        isLoading,
        refetch
    } = useQuery(
        ["getSpoMessages", props.selectedHotel],
        () => {
            return ActionService.GetSpoMessages({});

        },
        {
            onSuccess(data) {
                if (!props.spoDetail || (props.spoDetail && props.selectedHotel)) {
                    var hotelSpoMessage = _.find(data.body?.data, function (d) { return d.hotelId == props.selectedHotel });
                    form.setFieldsValue({ footerMeesage: hotelSpoMessage?.footerMeesage, senderShownName: hotelSpoMessage?.senderShownName, sendeName: hotelSpoMessage?.sendeName, mailSubject: hotelSpoMessage?.emailSubject, bodyMessage: hotelSpoMessage?.bodyMessage });
                }
                else {
                    if (!props.selectedHotel)
                        form.setFieldsValue({ footerMeesage: undefined, senderShownName: undefined, sendeName: undefined, mailSubject: undefined, bodyMessage: undefined });
                }
            },
            refetchOnWindowFocus: false,
            enabled: !!props.selectedHotel
        }
    );


    const handleAddClick = async (values: mdlSpoRoomPriceItem) => {
        try {
            await form.validateFields();
            var paramPair: mdlActionCreateParamPair = {};
            paramPair.index = props.createParamPairs?.length;
            var rPrice = values;
            rPrice!.key = `${form.getFieldValue("hotelId")}__${form.getFieldValue("roomTypeId")}__${form.getFieldValue("boardId")}__0`;
            paramPair.roomPrice = rPrice;
            paramPair.spoMessage = {
                bodyMessage: values.bodyMessage,
                emailSubject: values.mailSubject,
                footerMessage: values.footerMeesage,
                sendeName: values.sendeName,
                senderShownName: values.senderShownName,
                hotelId: values.hotelId
            }
            values.price = 0;
            values.discountRate = 0;
            var clonedPairs = _.cloneDeep(props.createParamPairs);
            clonedPairs.push(paramPair);
            props.createParamPairSetter(clonedPairs);
        }
        catch (e) {
            //
        }
    }

    const handleHotelChange = (value: mdlIdCodeNamePair) => {
        form.resetFields();
        form.setFieldValue("hotelId", value.id);
        form.setFieldValue("hotelName", value.localName);
        props.selectedHotelSetter(value.id);
    }

    const handleRoomTypeChange = (value: mdlIdCodeNamePair) => {
        form.setFieldValue("roomType", value.name);
        form.setFieldValue("roomTypeId", value.id);
    }

    const handleBoardChange = (value: mdlIdCodeNamePair) => {
        form.setFieldValue("board", value.name);
        form.setFieldValue("boardId", value.id);
    }

    const onFocus = () => {
        let i;
        const el = document.getElementsByClassName(
            "ant-select-selection-search-input"
        );
        for (i = 0; i < el.length; i++) {
            el[i].setAttribute(
                "autocomplete",
                "registration-select"
            );
        }
    }

    const handlePriceTypeChange = (value: string, index: number) => {
        var clonedPairs = _.cloneDeep(props.createParamPairs);
        var changedEntry = clonedPairs[index];
        if (changedEntry && changedEntry.roomPrice && value) {
            changedEntry.roomPrice.priceType = Number(value);
            clonedPairs[index] = changedEntry;
            props.createParamPairSetter(clonedPairs);
        }
    }

    const handlePriceChange = (value: number | null, index?: number) => {
        if (value != null && index != null) {
            var clonedPairs = _.cloneDeep(props.createParamPairs);
            var changedEntry = clonedPairs[index];
            if (changedEntry && changedEntry.roomPrice && value) {
                changedEntry.roomPrice.price = value;
                changedEntry.roomPrice.discountRate = 0;
                clonedPairs[index] = changedEntry;
                props.createParamPairSetter(clonedPairs);
            }
        }
    }

    const handleCurrencyChange = (value: string, index: number) => {
        var clonedPairs = _.cloneDeep(props.createParamPairs);
        var changedEntry = clonedPairs[index];
        if (changedEntry && changedEntry.roomPrice && value) {
            changedEntry.roomPrice.currency = Number(value);
            clonedPairs[index] = changedEntry;
            props.createParamPairSetter(clonedPairs);
        }
    }

    const handleDiscountChange = (value: number | null, index?: number) => {
        if (value != null && index != null) {
            var clonedPairs = _.cloneDeep(props.createParamPairs);
            var changedEntry = clonedPairs[index];
            if (changedEntry && changedEntry.roomPrice && value) {
                changedEntry.roomPrice.discountRate = value;
                changedEntry.roomPrice.price = 0;
                clonedPairs[index] = changedEntry;
                props.createParamPairSetter(clonedPairs);
            }
        }
    }

    const handleRemoveClick = (pair: mdlActionCreateParamPair, index: number) => {
        var clonedPairs = _.cloneDeep(props.createParamPairs);
        props.createParamPairSetter(_.filter(clonedPairs, function (c) { return c.index != index }));
    }

    const getInitialValues = () => {
        // if (props.spoDetail) {
        //     var firstData = _.first(props.spoDetail.body?.data);
        //     return {
        //         sendeName: firstData?.sendeName,
        //         senderShownName: firstData?.senderShownName,
        //         mailSubject: firstData?.mailSubject,
        //         bodyMessage: firstData?.bodyMessage,
        //         footerMeesage: firstData?.footerMeesage
        //     }
        // }
        // else {
        //     return {
        //         spoType: Number(enmActionType.ENTRY_BASED)
        //     }
        // }
        return {
            spoType: Number(enmActionType.ENTRY_BASED)
        }
    }


    return (
        <Layout>
            <Content >
                <Row style={{ margin: "25px" }}>
                    <Col span={24}>
                        <Form
                            form={form}
                            name="spo-form"
                            initialValues={getInitialValues()}
                            layout="vertical"
                            onFinish={(values: mdlSpoRoomPriceItem) => handleAddClick(values)}
                            autoComplete="off"
                        >
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item<mdlSpoRoomPriceItem> hidden
                                        label={t("action.create.hotel")}
                                        name="hotelName"
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item<mdlSpoRoomPriceItem>
                                        label={t("action.create.hotel")}
                                        name="hotelId"
                                        rules={[{ required: true, message: t("common.required") }]}
                                    >
                                        <HotelSelect value={props.selectedHotel} sendObject={true} onChange={(value: mdlIdCodeNamePair) => handleHotelChange(value)} />
                                    </Form.Item>
                                </Col>

                            </Row>
                            <Row gutter={16}>
                                <Col span={3}>
                                    <Form.Item name="accomDateStart"
                                        label={t("action.create.accomDateStart")}
                                        rules={[{ required: true, message: t("common.required") }]}
                                    >
                                        <SFDatePicker
                                            onChange={(date: Dayjs) => {
                                                if (date) {
                                                    form.setFieldValue("accomDateStart", new Date(
                                                        Date.UTC(
                                                            date.year(),
                                                            date.month(),
                                                            date.date(),
                                                            date.hour(),
                                                            date.minute(),
                                                            date.second()
                                                        )
                                                    ));
                                                } else {
                                                    form.setFieldValue("accomDateStart", null);
                                                }
                                            }} />
                                    </Form.Item>
                                </Col>
                                <Col span={3}>
                                    <Form.Item name="accomDateEnd"
                                        label={t("action.create.accomDateEnd")}
                                        rules={[{ required: true, message: t("common.required") }]} >
                                        <SFDatePicker
                                            onChange={(date: Dayjs) => {
                                                if (date) {
                                                    form.setFieldValue("accomDateEnd", new Date(
                                                        Date.UTC(
                                                            date.year(),
                                                            date.month(),
                                                            date.date(),
                                                            date.hour(),
                                                            date.minute(),
                                                            date.second()
                                                        )
                                                    ));
                                                } else {
                                                    form.setFieldValue("accomDateEnd", null);
                                                }
                                            }} />
                                    </Form.Item>
                                </Col>
                                <Col span={3}>
                                    <Form.Item name="sellStartDate"
                                        label={t("action.create.sellStartDate")}
                                        rules={[{ required: true, message: t("common.required") }]} >
                                        <SFDatePicker
                                            onChange={(date: Dayjs) => {
                                                if (date) {
                                                    form.setFieldValue("sellStartDate", new Date(
                                                        Date.UTC(
                                                            date.year(),
                                                            date.month(),
                                                            date.date(),
                                                            date.hour(),
                                                            date.minute(),
                                                            date.second()
                                                        )
                                                    ));
                                                } else {
                                                    form.setFieldValue("sellStartDate", null);
                                                }
                                            }} />
                                    </Form.Item>

                                </Col>
                                <Col span={3}>
                                    <Form.Item name="sellEndDate"
                                        label={t("action.create.sellEndDate")}
                                        rules={[{ required: true, message: t("common.required") }]} >
                                        <SFDatePicker
                                            onChange={(date: Dayjs) => {
                                                if (date) {
                                                    form.setFieldValue("sellEndDate", new Date(
                                                        Date.UTC(
                                                            date.year(),
                                                            date.month(),
                                                            date.date(),
                                                            date.hour(),
                                                            date.minute(),
                                                            date.second()
                                                        )
                                                    ));
                                                } else {
                                                    form.setFieldValue("sellEndDate", null);
                                                }
                                            }} />
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item<mdlSpoRoomPriceItem>
                                        label={t("action.create.sender")}
                                        name="sendeName"
                                        rules={[{ required: true, message: t("common.required") }]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item<mdlSpoRoomPriceItem>
                                        label={t("action.create.visibleName")}
                                        name="senderShownName"
                                        rules={[{ required: true, message: t("common.required") }]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={16}>
                                <Col span={6}>
                                    <Form.Item<mdlSpoRoomPriceItem> hidden
                                        label={t("action.create.roomType")}
                                        name="roomType"
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item<mdlSpoRoomPriceItem>
                                        label={t("action.create.roomType")}
                                        name="roomTypeId"
                                        rules={[{ required: true, message: t("common.required") }]}
                                    >
                                        <HotelRoomTypeNameSelect onChange={handleRoomTypeChange} sendObject={true} hotelId={props.selectedHotel} />
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item<mdlSpoRoomPriceItem> hidden
                                        label={t("action.create.board")}
                                        name="board"
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item<mdlSpoRoomPriceItem>
                                        label={t("action.create.board")}
                                        name="boardId"
                                        rules={[{ required: true, message: t("common.required") }]}
                                    >
                                        <HotelBoardNameSelect onChange={handleBoardChange} sendObject={true} hotelId={props.selectedHotel} />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item<mdlSpoRoomPriceItem>
                                        label={t("action.create.mailSubject")}
                                        name="mailSubject"
                                        rules={[{ required: true, message: t("common.required") }]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                            </Row>


                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item<mdlSpoRoomPriceItem>
                                        label={t("action.create.actionNote")}
                                        name="spoNote"
                                        rules={[{ required: true, message: t("common.required") }]}
                                    >
                                        <Input.TextArea rows={3} />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item<mdlSpoRoomPriceItem>
                                        label={t("action.create.mailContent")}
                                        name="bodyMessage"
                                        rules={[{ required: true, message: t("common.required") }]}
                                    >
                                        <Input.TextArea rows={3} />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item<mdlSpoRoomPriceItem>
                                        label={t("action.create.actionType")}
                                        name="spoType"
                                        rules={[{ required: true, message: t("common.required") }]}
                                    >
                                        <Flex>
                                            <Radio.Group defaultValue={Number(enmActionType.ENTRY_BASED)} onChange={(e: RadioChangeEvent) => form.setFieldValue("spoType", Number(e.target.value))}>
                                                <Radio value={Number(enmActionType.ENTRY_BASED)}>{t("action.create.actionTypeEntryBased")}</Radio>
                                                <Radio value={Number(enmActionType.ACCOM_BASED)}>{t("action.create.actionTypeAccomBased")}</Radio>
                                            </Radio.Group>
                                        </Flex>
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item<mdlSpoRoomPriceItem>
                                        label={t("action.create.mailFooter")}
                                        name="footerMeesage"
                                        rules={[{ required: true, message: t("common.required") }]}
                                    >
                                        <Input.TextArea rows={3} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item>
                                <Flex align={"center"} justify="flex-start">
                                    <Button type="primary" htmlType="submit">{t("common.add")}</Button>
                                </Flex>
                            </Form.Item>

                        </Form>
                    </Col>

                </Row>
                {
                    props.createParamPairs && props.createParamPairs.length > 0
                    &&
                    <Card>
                        <Row gutter={16} style={{ height: "25px" }} key={"fixed-header"}>
                            <Col span={6}>
                                <span>
                                    {t("action.create.hotelRoomBoard")}
                                </span>
                            </Col>
                            <Col span={4}>
                                <span>
                                    {t("action.create.accomStartEndDate")}
                                </span>
                            </Col>
                            <Col span={2}>
                                <span>
                                    {t("action.create.spoType")}
                                </span>
                            </Col>
                            <Col span={2}>
                                <span>
                                    {t("action.create.priceType")}
                                </span>
                            </Col>
                            <Col span={2}>
                                <span>
                                    {t("action.create.price")}
                                </span>
                            </Col>
                            <Col span={2}>
                                <span>
                                    {t("action.create.currency")}
                                </span>
                            </Col>
                            <Col span={2}>
                                <span>
                                    {t("action.create.discount")}
                                </span>
                            </Col>
                            <Col span={2}>
                                <span>
                                    {t("action.create.note")}
                                </span>
                            </Col>
                            <Col>
                                <span>
                                    {t("common.actions")}
                                </span>
                            </Col>
                        </Row>
                        <>
                            {
                                props.createParamPairs &&
                                props.createParamPairs.map((pair: mdlActionCreateParamPair, index: number) => (
                                    <Card key={index}>
                                        <Row gutter={16} style={{ height: "35px" }}>
                                            <Col span={6}>
                                                <span>
                                                    {`${pair.roomPrice?.hotelName} / ${pair.roomPrice?.roomType} / ${pair.roomPrice?.board}`}
                                                </span>
                                            </Col>
                                            <Col span={4}>
                                                <span>
                                                    {dayjs(pair.roomPrice?.accomDateStart).format("DD.MM.YYYY")} - {dayjs(pair.roomPrice?.accomDateEnd).format("DD.MM.YYYY")}
                                                </span>
                                            </Col>
                                            <Col span={2}>
                                                <span>
                                                    {pair.roomPrice?.spoType == enmActionType.ACCOM_BASED ?
                                                        t("action.create.actionTypeAccomBased") :
                                                        t("action.create.actionTypeEntryBased")}
                                                </span>
                                            </Col>
                                            <Col span={2}>
                                                <Select
                                                    style={{ width: "100%" }}
                                                    size="middle"
                                                    onFocus={onFocus}
                                                    onChange={(value: string) => handlePriceTypeChange(value, index)}
                                                    value={pair.roomPrice?.priceType?.toString()}
                                                    filterOption={(input, option) =>
                                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                                    }
                                                    options={
                                                        [
                                                            { label: t("action.create.priceTypePerPerson"), value: enmPriceType.PER_PERSON.toString() },
                                                            { label: t("action.create.priceTypePerRoom"), value: enmPriceType.PER_ROOM.toString() }
                                                        ]
                                                    }
                                                />
                                            </Col>
                                            <Col span={2}>
                                                <InputNumber defaultValue={0} onChange={(value: number | null) => handlePriceChange(value, index)} style={{ width: "100%" }} value={pair.roomPrice?.price} />
                                            </Col>
                                            <Col span={2}>
                                                <Select
                                                    style={{ width: "100%" }}
                                                    size="middle"
                                                    onFocus={onFocus}
                                                    onChange={(value: string) => handleCurrencyChange(value, index)}
                                                    value={pair.roomPrice?.currency?.toString()}
                                                    filterOption={(input, option) =>
                                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                                    }
                                                    options={
                                                        [
                                                            { label: "TL", value: enmCurrency.TL.toString() },
                                                            { label: "EURO", value: enmCurrency.EURO.toString() },
                                                            { label: "USD", value: enmCurrency.USD.toString() },
                                                            { label: "GBP", value: enmCurrency.GBP.toString() },
                                                        ]
                                                    }
                                                />
                                            </Col>
                                            <Col span={2}>
                                                <InputNumber defaultValue={0} onChange={(value: number | null) => handleDiscountChange(value, index)} style={{ width: "100%" }} value={pair.roomPrice?.discountRate} />
                                            </Col>
                                            <Col span={2}>
                                                <span>{pair.roomPrice?.spoNote}</span>
                                            </Col>
                                            <Col>
                                                <Space size="middle">
                                                    <Popconfirm
                                                        title={t("common.deleteWarning")}
                                                        description={t("common.deleteDescription")}
                                                        okText={t("common.okConfirm")}
                                                        cancelText={t("common.cancelConfirm")}
                                                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                                                        onConfirm={() => handleRemoveClick(pair, index)}
                                                    >
                                                        <Button type="primary" danger>
                                                            {t("common.delete")}
                                                        </Button>
                                                    </Popconfirm>

                                                </Space>
                                            </Col>
                                        </Row>
                                    </Card>
                                ))
                            }
                        </>
                    </Card>
                }
            </Content>
        </Layout>
    )
}